;(function (w) {
	/**
	 * 请求方法
	 */
	let ajaxFun = function (url, data, options) {
		return new Promise((resolve, reject) => {
			var baseUrl = '';
			if (w.plugin.env() == 'development') {
				// 沙盒参数
				data.app_env = 'sandbox';
				// baseUrl = 'https://testapidev.patozon.net'; //开发环境
				baseUrl = 'https://testapi.patozon.net'; //测试环境
			} else {
				baseUrl = 'https://release-api.patozon.net'; //预发布环境
				// baseUrl = 'https://brand-api.patozon.net'; //生产环境
			}
			data.store_id = 10;
			var config = {
				type: 'POST',
				contentType: "application/json; charset=utf-8",
				dataType: 'json',
				jionUrl: true
			}
			options && (config = Object.assign(config, options));
			// 是否拼接url
			config.jionUrl && (url = baseUrl + url)
			delete config.jionUrl
			if (config.type == 'POST' && config.dataType == 'json') {
				data = JSON.stringify(data)
			}
			$.ajax({
				url: url,
				data: data,
				complete: response => resolve(response),
				error: err => reject(err),
				...config
			});
		})
	}

	let Apis = {
    // 获取延保订单
    getWarranyList: function(data) {
      return ajaxFun('/api/shop/order/list', data)
    },
    // 绑定订单
		bindOrder: function(data) {
			return ajaxFun('/api/shop/order/bind', data)
    },
    // 获取用户信息
    getUserInfo: function(data) {
      return ajaxFun('/api/shop/customer/info', data)
    },
    // 编辑用户信息
    editUserInfo: function(data) {
      return ajaxFun('/api/shop/customer/edit', data)
    },
      // 获取iframe配置信息
    getActivityData: function(data) {
      return ajaxFun('/api/shop/activity/getActivityData', data)
    },
		// 注册接口
    register: function (data) {
      let result = data
      return new Promise((resolve, reject) => {
        ajaxFun('/api/shop/customer/createCustomer', data).then(res => {
          if (res.code == 1) {
            resolve(result);
          } else {
            let errMsg = res.msg;
            if (res.code == 10029) {
              errMsg = 'There is already an account with this email address.'
            } else if (res.code == 10028) {
              errMsg = 'Your registration account IP repeated, please re-enter your info to register.'
            } else if (res.code == 10016) {
              errMsg = 'Registration Failed'
            }
            reject(errMsg)
          }
        }).catch(eer => {
					reject('Network anomaly')
				})
      })
		},
		// 登录接口
    login: function (result) {
      let data = {
        'customer[email]': result.account,
        'customer[password]': result.password,
        form_type: 'customer_login',
        utf8: '✓'
      }
      return new Promise((resolve, reject) => {
        ajaxFun('/account/login', data, {
          contentType: 'application/x-www-form-urlencoded; charset=utf-8',
          dataType: 'html',
          async: false,
          jionUrl: false
        }).then(responseText => {
          let errArr = $($.parseHTML(responseText)).find('#customer_login .errors')
          if (errArr.length > 0) {
            const errMsg = errArr[0].innerText;
            reject(errMsg) // 获取错误内容
          } else {
            resolve()
          }
        }).catch(err => {
          reject()
        })
      });
		},
	}
	// 插入window
	w.apis = Apis;
}(this))